const AdminContentContainer = ({ children }) => {
  return (
    <main>
      <div style={{ margin: 50 }}>{children}</div>
    </main>
  )
}

export default AdminContentContainer
